// Minimal strip if DOMPurify not installed — prefer DOMPurify when available
let purify = null;
try {
  purify = require("dompurify");
  if (purify && purify.default) purify = purify.default;
} catch (e) {
  purify = null;
}

export default function sanitizeHtml(html) {
  if (purify && typeof window !== "undefined") {
    try {
      return purify.sanitize(html || "", {
        ALLOWED_TAGS: ["b", "i", "u", "ul", "ol", "li", "br", "p", "em", "strong", "span"],
        ALLOWED_ATTR: [],
      });
    } catch (e) {}
  }
  return String(html || "")
    .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, "")
    .replace(/on\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, "")
    .replace(/javascript\s*:/gi, "");
}
